import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QueryParam } from '../query-param';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-pin-dailog',
  templateUrl: './pin-dailog.component.html',
  styleUrls: ['./pin-dailog.component.css']
})
export class PinDailogComponent implements OnInit {

  constructor(private apiService: ApiService,private  activeModal: NgbActiveModal) { }

  mobileNumber!: number;

  addbalance = '';

  queryParam!: QueryParam;


  ngOnInit(): void {
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );
  }
  
  submit(){
    console.log(this.mobileNumber);
    this.apiService.cancelPinSubscriptionForTpay(this.mobileNumber, this.queryParam.mobileNumber, this.queryParam.operatorCode, this.queryParam.id).subscribe(
      (response: any) => {
        console.log('cancelPinSubscriptionForTpay Reponse ===============', response);
        if(response === true){
          this.queryParam.mobileNumber = this.mobileNumber;
          this.queryParam.sub = true;
          this.queryParam.popup = false;
          let storageName = this.queryParam.id+this.queryParam.operator+this.queryParam.biller;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
                    console.log('Response :', this.queryParam);
          this.activeModal.close();
        }else{
        
          this.addbalance = 'INVALID PIN NUMBER';
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

}
